import type { Message } from "@/types/Transcript"

/** Which side of the conversation a transcript message belongs to. */
export type Speaker = "persona" | "agent"

/**
 * Resolves the side of the conversation a stored transcript message belongs to.
 *
 * Persona speech is stored as `role: "user"` and agent speech as
 * `role: "assistant"`. A tool call is stored as `role: "tool"` whichever side
 * made it, and `tool_call_owner` says whose it is. A tool call with no owner is
 * the agent's, matching the backend default.
 */
export function messageSpeaker(
  message: Pick<Message, "role" | "tool_call_owner">,
): Speaker {
  if (message.role === "user") {
    return "persona"
  }
  if (message.role === "tool" && message.tool_call_owner === "user") {
    return "persona"
  }
  return "agent"
}
